import React from "react";
import { useQuery } from "react-query";
import HeroBike from "./HeroBike";

const Hero = () => {
  const { isLoading, data: bikes } = useQuery({
    queryKey: ["Bikes Suzuki"],
    queryFn: () =>
      fetch("https://bike-resell-server-hasanalibd.vercel.app/bikes/Hero").then(
        (res) => res.json()
      ),
  });
  console.log(bikes);

  return (
    <div>
      {bikes?.map((bike) => (
        <HeroBike key={bike._id} bike={bike}></HeroBike>
      ))}
    </div>
  );
};

export default Hero;
